// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"d5134398","453":"f7a30d10"}[chunkId] + ".chunk.js";
};